module.exports = __webpack_public_path__ + "static/media/Elvid new.f49822ce.jpg";